import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ModalClosed } from "~misc/icons";
import { money } from "~hooks/useHelpers";

const ExcluirNegociacao = ({ isOpen, onClose, onConfirm, mensagem, data, setSelected, loading = false }) => {
  const modalClasses = isOpen ? "fixed inset-0 bg-black bg-opacity-0 z-[99999]" : "hidden";
  const overlayClasses = isOpen
    ? "fixed inset-0 w-full h-full bg-black opacity-50 z-40 border-none p-0 m-0 cursor-default"
    : "hidden";

  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setSelectedOptions([]);
    }
  }, [isOpen]);

  const options = [
    data?.faixaF && {
      name: "faixa",
      label: "FAIXA",
      value: `${data?.faixa}%`,
      idCliente: data?.clienteId,
      idProduto: data?.produtoId,
      idFilial: data?.filialId,
      id: data?.id,
    },
    data?.color.fob && {
      name: "fob",
      label: "C.E. FOB",
      value: `${money(data?.precoFinalFOB)}`,
      idCliente: data?.clienteId,
      idProduto: data?.produtoId,
      idFilial: data?.filialId,
      id: data?.id,
    },
    data?.color.cif && {
      name: "cif",
      label: "C.E. CIF",
      value: `${money(data?.precoFinalCIF)}`,
      idCliente: data?.clienteId,
      idProduto: data?.produtoId,
      idFilial: data?.filialId,
      id: data?.id,
    },
  ].filter(Boolean);

  const handleCheckboxChange = (option) => {
    setSelectedOptions((prev) =>
      prev.some((item) => item.name === option.name)
        ? prev.filter((item) => item.name !== option.name)
        : [...prev, option]
    );
  };

  const handleDelete = () => {
    onConfirm(selectedOptions);
  };

  useEffect(() => {
    if (setSelected) setSelected(selectedOptions);
  }, [selectedOptions]);

  return (
    <div className={modalClasses}>
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-white px-14 py-14 rounded-[20px] shadow-lg z-50 text-center relative">
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
            >
              <ModalClosed />
            </button>
          </div>
          <h3 className="mt-2 font-bold text-2xl max-w-[400px]">{mensagem}</h3>

          <div className="p-4">
            {options.map((option) => (
              <div
                key={option.name}
                className={`flex items-center p-4 mb-2 rounded-lg ${
                  selectedOptions.some((item) => item.name === option.name) ? "bg-blue-100" : "bg-gray-200"
                }`}
              >
                <input
                  type="checkbox"
                  checked={selectedOptions.some((item) => item.name === option.name)}
                  onChange={() => handleCheckboxChange(option)}
                  className="form-checkbox h-5 w-5 text-blue-600"
                />
                <span className="ml-3 font-bold text-gray-700">
                  {option.label} ({option.value})
                </span>
              </div>
            ))}
            <button
              className="
                    bg-white border-2 border-red-500 text-red-500 rounded-lg mt-4
                    hover:bg-red-500 hover:text-white hover:border-transparent
                    transition duration-300 py-4 px-10
                "
              disabled={selectedOptions.length === 0 || loading}
              onClick={handleDelete}
            >
              DELETAR
            </button>
          </div>
        </div>
        {isOpen && (
          <button type="button" className={overlayClasses} aria-label="Fechar modal" tabIndex={0} onClick={onClose} />
        )}
      </div>
    </div>
  );
};

ExcluirNegociacao.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  mensagem: PropTypes.string,
  data: PropTypes.object,
  setSelected: PropTypes.func,
  loading: PropTypes.bool,
};

export default ExcluirNegociacao;
